var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgEthereum = function SvgEthereum(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#627EEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3735 3V9.6525L17.9963 12.165L12.3735 3Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3735 3L6.75 12.165L12.3735 9.6525V3Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3735 16.476V20.9963L18 13.212L12.3735 16.476Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3735 20.9963V16.4753L6.75 13.212L12.3735 20.9963Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3735 15.4298L17.9963 12.1651L12.3735 9.65405V15.4298Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.1651L12.3735 15.4298V9.65405L6.75 12.1651Z",
    fill: "white",
    fillOpacity: 0.602
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgEthereum);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,IDxzdmcgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTIgMjRDMTguNjI3NCAyNCAyNCAxOC42Mjc0IDI0IDEyQzI0IDUuMzcyNTggMTguNjI3NCAwIDEyIDBDNS4zNzI1OCAwIDAgNS4zNzI1OCAwIDEyQzAgMTguNjI3NCA1LjM3MjU4IDI0IDEyIDI0WiIgZmlsbD0iIzYyN0VFQSIvPgogICAgPHBhdGggZD0iTTEyLjM3MzUgM1Y5LjY1MjVMMTcuOTk2MyAxMi4xNjVMMTIuMzczNSAzWiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC42MDIiLz4KICAgIDxwYXRoIGQ9Ik0xMi4zNzM1IDNMNi43NSAxMi4xNjVMMTIuMzczNSA5LjY1MjVWM1oiIGZpbGw9IndoaXRlIi8+CiAgICA8cGF0aCBkPSJNMTIuMzczNSAxNi40NzZWMjAuOTk2M0wxOCAxMy4yMTJMMTIuMzczNSAxNi40NzZaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjYwMiIvPgogICAgPHBhdGggZD0iTTEyLjM3MzUgMjAuOTk2M1YxNi40NzUzTDYuNzUgMTMuMjEyTDEyLjM3MzUgMjAuOTk2M1oiIGZpbGw9IndoaXRlIi8+CiAgICA8cGF0aCBkPSJNMTIuMzczNSAxNS40Mjk4TDE3Ljk5NjMgMTIuMTY1MUwxMi4zNzM1IDkuNjU0MDVWMTUuNDI5OFoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgogICAgPHBhdGggZD0iTTYuNzUgMTIuMTY1MUwxMi4zNzM1IDE1LjQyOThWOS42NTQwNUw2Ljc1IDEyLjE2NTFaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjYwMiIvPgogICAgPC9zdmc+";